<div class="main-layout">
    <div class="header-container">
        <app-quotation-top-header></app-quotation-top-header>
        <app-quotation-header (collapsedState)="onHeaderCollapse($event)"></app-quotation-header>
    </div>
    <div class="enterprise-dashboard" [class.expanded]="!isHeaderCollapsed" [class.collapsed]="isHeaderCollapsed">
        <!-- Enhanced Header Section -->
        <div class="dashboard-header">
            <div class="header-container">
                <div class="brand-section">
                    <div class="brand-logo">
                        <i class="pi pi-chart-bar"></i>
                    </div>
                    <div class="brand-info">
                        <h1>Weekly Purchase Order Dashboard</h1>
                        <p>Enterprise Analytics & Performance Metrics</p>
                        <div class="current-period-info"
                            *ngIf="yearType === 'calendar' && selectedYear === getCurrentPeriodInfo().year">
                            <i class="pi pi-info-circle"></i>
                            <span>Data shown up to {{ getCurrentPeriodInfo().month }} Week {{
                                getCurrentPeriodInfo().week
                                }}, {{ getCurrentPeriodInfo().year }}</span>
                        </div>
                        <div class="current-period-info" *ngIf="yearType === 'financial'">
                            <i class="pi pi-info-circle"></i>
                            <span>Data shown for financial year {{ selectedYear }}-{{ selectedYear + 1 }}</span>
                        </div>
                    </div>
                </div>
                <div class="header-controls">
                    <div class="filter-group">
                        <label>Year Type</label>
                        <p-dropdown [options]="yearTypeOptions" [(ngModel)]="yearType" (onChange)="onYearTypeChange()"
                            placeholder="Select Year Type" optionLabel="label" optionValue="value"
                            styleClass="year-type-selector">
                        </p-dropdown>
                    </div>
                    <div class="filter-group">
                        <label>{{ yearType === 'calendar' ? 'Calendar Year' : 'Financial Year' }}</label>
                        <p-dropdown [options]="yearOptions" [(ngModel)]="selectedYear" (onChange)="onYearChange()"
                            placeholder="Select Year" optionLabel="label" optionValue="value"
                            styleClass="year-selector">
                        </p-dropdown>
                    </div>
                    <div class="action-buttons">
                        <p-button icon="pi pi-refresh" label="Refresh Data" (onClick)="loadData()"
                            styleClass="p-button-outlined refresh-btn">
                        </p-button>
                        <p-button icon="pi pi-upload" label="Upload KIK#F1" (onClick)="showKikF1UploadDialog()"
                            styleClass="p-button-outlined kikf1-upload-btn"
                            pTooltip="Upload Excel file with KIK#F1 data">
                        </p-button>
                        <p-button icon="pi pi-download" label="Export All" (onClick)="exportAllData()"
                            styleClass="export-btn">
                        </p-button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Executive Summary Cards -->
        <div class="executive-summary">
            <div class="summary-grid">
                <div class="metric-card primary-metric">
                    <div class="metric-header">
                        <span class="metric-label">Total Order Value</span>
                        <i class="pi pi-dollar metric-icon"></i>
                    </div>
                    <div class="metric-value">${{ formatCurrency(yearlyTotals.total) }}</div>
                    <div class="metric-trend positive">
                    </div>
                </div>

                <div class="metric-card secondary-metric">
                    <div class="metric-header">
                        <span class="metric-label">Total Order</span>
                        <i class="pi pi-shopping-cart metric-icon"></i>
                    </div>
                    <div class="metric-value">{{ formatNumber(yearlyQuantities.total) }}</div>
                    <div class="metric-trend positive">
                    </div>
                </div>

                <div class="metric-card tertiary-metric">
                    <div class="metric-header">
                        <span class="metric-label">Avg Order Value</span>
                        <i class="pi pi-calculator metric-icon"></i>
                    </div>
                    <div class="metric-value">${{ formatCurrency(calculateAverageOrderValue()) }}</div>
                    <div class="metric-trend neutral">
                    </div>
                </div>

                <div class="metric-card quaternary-metric">
                    <div class="metric-header">
                        <span class="metric-label">AVG Quantity per Month</span>
                        <i class="pi pi-chart-line metric-icon"></i>
                    </div>
                    <div class="metric-value">{{ formatNumber(getAvgQuantityPerMonth()) }}</div>
                    <div class="metric-trend stable">
                        <i class="pi pi-trending-up"></i>
                        <span>Monthly Average</span>
                    </div>
                </div>
            </div>
        </div>


        <!-- Enhanced Analytics Section -->
        <div class="analytics-container">
            <!-- Revenue Analysis Panel -->
            <div class="analytics-panel revenue-panel">
                <div class="panel-header">
                    <div class="panel-title">
                        <i class="pi pi-chart-line"></i>
                        <h2>Custormer Wise Weekly Order Intake</h2>
                        <span class="panel-subtitle">
                            Monthly revenue breakdown by customer
                            <span class="current-period" *ngIf="selectedYear === getCurrentPeriodInfo().year">
                                (Through {{ getCurrentPeriodInfo().month }} Week {{ getCurrentPeriodInfo().week }})
                            </span>
                        </span>
                    </div>

                    <div class="panel-actions">
                        <p-button icon="pi pi-filter" styleClass="p-button-text panel-btn" pTooltip="Filter Options">
                        </p-button>
                        <p-button icon="pi pi-download" styleClass="p-button-text panel-btn"
                            (onClick)="exportData('revenue')" pTooltip="Export Revenue Data">
                        </p-button>
                        <p-button icon="pi pi-expand" styleClass="p-button-text panel-btn" pTooltip="Expand View">
                        </p-button>
                    </div>
                </div>

                <div class="panel-content">
                    <p-table [value]="monthlyData" [scrollable]="true" scrollHeight="650px"
                        styleClass="enterprise-table revenue-table" [loading]="isLoading" [paginator]="false"
                        dataKey="period">

                        <ng-template pTemplate="header">
                            <tr>
                                <th class="period-column">
                                    <div class="header-cell">
                                        <i class="pi pi-calendar"></i>
                                        <span>Period</span>
                                    </div>
                                </th>
                                <th class="customer-column" *ngFor="let customer of customerList">
                                    <div class="header-cell">
                                        <span>{{ customer.shortName }}</span>
                                        <small>{{ customer.fullName }}</small>
                                    </div>
                                </th>
                                <th class="total-column">
                                    <div class="header-cell total-header">
                                        <i class="pi pi-calculator"></i>
                                        <span>Total Revenue</span>
                                    </div>
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
                            <tr [ngClass]="{
    'month-header': row.isMonthHeader,
    'month-total': row.isMonthTotal,
    'week-row': row.isWeekRow,
    'current-week': isCurrentWeek(row),
    'even-row': rowIndex % 2 === 0
  }">
                                <td class="period-cell">
                                    <div class="period-content" [ngClass]="{
                  'month-header-content': row.isMonthHeader,
                  'month-total-content': row.isMonthTotal,
                  'week-content': row.isWeekRow
                }">
                                        <i class="pi" [ngClass]="{
                    'pi-calendar': row.isMonthHeader,
                    'pi-calculator': row.isMonthTotal,
                    'pi-clock': row.isWeekRow
                  }"></i>
                                        <span [ngClass]="{'font-bold': row.isMonthHeader || row.isMonthTotal}">
                                            {{ row.period }}
                                        </span>
                                    </div>
                                </td>

                                <td class="data-cell" [ngClass]="{'total-cell': row.isMonthTotal}">
                                    <span class="currency-value">{{ formatCurrency(row.ecs) }}</span>
                                </td>
                                <td class="data-cell" [ngClass]="{'total-cell': row.isMonthTotal}">
                                    <span class="currency-value">{{ formatCurrency(row.eltech) }}</span>
                                </td>
                                <td class="data-cell" [ngClass]="{'total-cell': row.isMonthTotal}">
                                    <span class="currency-value">{{ formatCurrency(row.ses) }}</span>
                                </td>
                                <td class="data-cell" [ngClass]="{'total-cell': row.isMonthTotal}">
                                    <span class="currency-value">{{ formatCurrency(row.aps) }}</span>
                                </td>
                                <td class="data-cell" [ngClass]="{'total-cell': row.isMonthTotal}">
                                    <span class="currency-value">{{ formatCurrency(row.noratel) }}</span>
                                </td>
                                <td class="data-cell" [ngClass]="{'total-cell': row.isMonthTotal}">
                                    <span class="currency-value">{{ formatCurrency(row.cbi) }}</span>
                                </td>
                                <td class="data-cell" [ngClass]="{'total-cell': row.isMonthTotal}">
                                    <span class="currency-value">{{ formatCurrency(row.f1) }}</span>
                                </td>

                                <td class="total-column-cell" [ngClass]="{'grand-total-cell': row.isMonthTotal}">
                                    <div class="total-value">
                                        <span class="amount">{{ formatCurrency(row.total) }}</span>
                                        <i class="pi pi-arrow-right value-indicator"></i>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="footer">
                            <tr class="grand-total-row">
                                <td class="period-cell">
                                    <div class="grand-total-label">
                                        <i class="pi pi-chart-pie"></i>
                                        <strong>Annual Total</strong>
                                    </div>
                                </td>
                                <td><strong class="grand-total-value">{{ formatCurrency(yearlyTotals.ecs) }}</strong>
                                </td>
                                <td><strong class="grand-total-value">{{ formatCurrency(yearlyTotals.eltech) }}</strong>
                                </td>
                                <td><strong class="grand-total-value">{{ formatCurrency(yearlyTotals.ses) }}</strong>
                                </td>
                                <td><strong class="grand-total-value">{{ formatCurrency(yearlyTotals.aps) }}</strong>
                                </td>
                                <td><strong class="grand-total-value">{{ formatCurrency(yearlyTotals.noratel)
                                        }}</strong>
                                </td>
                                <td><strong class="grand-total-value">{{ formatCurrency(yearlyTotals.cbi) }}</strong>
                                </td>
                                <td><strong class="grand-total-value">{{ formatCurrency(yearlyTotals.f1) }}</strong>
                                </td>
                                <td class="total-column-cell">
                                    <div class="grand-total-amount">
                                        <strong>{{ formatCurrency(yearlyTotals.total) }}</strong>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>

            <!-- Quantity Analysis Panel -->
            <div class="analytics-panel quantity-panel">
                <div class="panel-header">
                    <div class="panel-title">
                        <i class="pi pi-box"></i>
                        <h2>Custormer Wise Weekly Numbers of Order Intake</h2>
                        <span class="panel-subtitle">
                            Monthly order volume by customer
                            <span class="current-period" *ngIf="selectedYear === getCurrentPeriodInfo().year">
                                (Through {{ getCurrentPeriodInfo().month }} Week {{ getCurrentPeriodInfo().week }})
                            </span>
                        </span>
                    </div>

                    <div class="panel-actions">
                        <p-button icon="pi pi-filter" styleClass="p-button-text panel-btn" pTooltip="Filter Options">
                        </p-button>
                        <p-button icon="pi pi-download" styleClass="p-button-text panel-btn"
                            (onClick)="exportData('quantity')" pTooltip="Export Quantity Data">
                        </p-button>
                        <p-button icon="pi pi-expand" styleClass="p-button-text panel-btn" pTooltip="Expand View">
                        </p-button>
                    </div>
                </div>

                <div class="panel-content">
                    <p-table [value]="monthlyData" [scrollable]="true" scrollHeight="650px"
                        styleClass="enterprise-table quantity-table" [loading]="isLoading" [paginator]="false"
                        dataKey="period">

                        <!-- Similar structure as revenue table but with quantity data -->
                        <ng-template pTemplate="header">
                            <tr>
                                <th class="period-column">
                                    <div class="header-cell">
                                        <i class="pi pi-calendar"></i>
                                        <span>Period</span>
                                    </div>
                                </th>
                                <th class="customer-column" *ngFor="let customer of customerList">
                                    <div class="header-cell">
                                        <span>{{ customer.shortName }}</span>
                                        <small>{{ customer.fullName }}</small>
                                    </div>
                                </th>
                                <th class="total-column">
                                    <div class="header-cell total-header">
                                        <i class="pi pi-shopping-cart"></i>
                                        <span>Total Orders</span>
                                    </div>
                                </th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
                            <tr [ngClass]="{
              'month-header': row.isMonthHeader,
              'month-total': row.isMonthTotal,
              'week-row': row.isWeekRow,
              'even-row': rowIndex % 2 === 0
            }">
                                <td class="period-cell">
                                    <div class="period-content" [ngClass]="{
                  'month-header-content': row.isMonthHeader,
                  'month-total-content': row.isMonthTotal,
                  'week-content': row.isWeekRow
                }">
                                        <i class="pi" [ngClass]="{
                    'pi-calendar': row.isMonthHeader,
                    'pi-calculator': row.isMonthTotal,
                    'pi-clock': row.isWeekRow
                  }"></i>
                                        <span [ngClass]="{'font-bold': row.isMonthHeader || row.isMonthTotal}">
                                            {{ row.period }}
                                        </span>
                                    </div>
                                </td>

                                <td class="data-cell" [ngClass]="{'total-cell': row.isMonthTotal}">
                                    <span class="quantity-value">{{ formatNumber(row.ecsQty) }}</span>
                                </td>
                                <td class="data-cell" [ngClass]="{'total-cell': row.isMonthTotal}">
                                    <span class="quantity-value">{{ formatNumber(row.eltechQty) }}</span>
                                </td>
                                <td class="data-cell" [ngClass]="{'total-cell': row.isMonthTotal}">
                                    <span class="quantity-value">{{ formatNumber(row.sesQty) }}</span>
                                </td>
                                <td class="data-cell" [ngClass]="{'total-cell': row.isMonthTotal}">
                                    <span class="quantity-value">{{ formatNumber(row.apsQty) }}</span>
                                </td>
                                <td class="data-cell" [ngClass]="{'total-cell': row.isMonthTotal}">
                                    <span class="quantity-value">{{ formatNumber(row.noratelQty) }}</span>
                                </td>
                                <td class="data-cell" [ngClass]="{'total-cell': row.isMonthTotal}">
                                    <span class="quantity-value">{{ formatNumber(row.cbiQty) }}</span>
                                </td>
                                <td class="data-cell" [ngClass]="{'total-cell': row.isMonthTotal}">
                                    <span class="quantity-value">{{ formatNumber(row.f1Qty) }}</span>
                                </td>

                                <td class="total-column-cell" [ngClass]="{'grand-total-cell': row.isMonthTotal}">
                                    <div class="total-value">
                                        <span class="amount">{{ formatNumber(row.totalQty) }}</span>
                                        <i class="pi pi-arrow-right value-indicator"></i>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="footer">
                            <tr class="grand-total-row">
                                <td class="period-cell">
                                    <div class="grand-total-label">
                                        <i class="pi pi-chart-pie"></i>
                                        <strong>Annual Total</strong>
                                    </div>
                                </td>
                                <td><strong class="grand-total-value">{{ formatNumber(yearlyQuantities.ecs) }}</strong>
                                </td>
                                <td><strong class="grand-total-value">{{ formatNumber(yearlyQuantities.eltech)
                                        }}</strong>
                                </td>
                                <td><strong class="grand-total-value">{{ formatNumber(yearlyQuantities.ses) }}</strong>
                                </td>
                                <td><strong class="grand-total-value">{{ formatNumber(yearlyQuantities.aps) }}</strong>
                                </td>
                                <td><strong class="grand-total-value">{{ formatNumber(yearlyQuantities.noratel)
                                        }}</strong>
                                </td>
                                <td><strong class="grand-total-value">{{ formatNumber(yearlyQuantities.cbi) }}</strong>
                                </td>
                                <td><strong class="grand-total-value">{{ formatNumber(yearlyQuantities.f1) }}</strong>
                                </td>
                                <td class="total-column-cell">
                                    <div class="grand-total-amount">
                                        <strong>{{ formatNumber(yearlyQuantities.total) }}</strong>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
        <!-- Summary Tables Section -->
        <div class="summary-tables-container">
            <div class="summary-section-header">
                <h2>
                    <i class="pi pi-chart-pie"></i>
                    Annual Summary by Customer
                </h2>
                <p>Consolidated monthly performance overview for {{ selectedYear }}</p>
            </div>

            <div class="summary-tables-grid">
                <!-- Revenue Summary Table -->
                <div class="summary-panel revenue-summary">
                    <div class="summary-header">
                        <div class="summary-title">
                            <i class="pi pi-dollar"></i>
                            <h3>Customer Wise Monthly Order Intake Summary </h3>
                            <span>Monthly revenue by customer</span>
                        </div>
                        <div class="summary-actions">
                            <p-button icon="pi pi-download" styleClass="p-button-text summary-btn"
                                (onClick)="exportSummary('revenue')" pTooltip="Export Revenue Summary">
                            </p-button>
                        </div>
                    </div>

                    <div class="summary-content">
                        <p-table [value]="revenueSummaryData" [scrollable]="true" scrollHeight="600px"
                            styleClass="summary-table revenue-summary-table" [paginator]="false" dataKey="customer">

                            <ng-template pTemplate="header">
                                <tr>
                                    <th class="customer-name-column">
                                        <div class="summary-header-cell">
                                            <i class="pi pi-building"></i>
                                            <span>Customer</span>
                                        </div>
                                    </th>
                                    <th class="month-column" *ngFor="let month of getDisplayMonths()">
                                        <div class="summary-header-cell">
                                            <span>{{ month.shortName }}</span>
                                            <small>{{ month.fullName }}</small>
                                        </div>
                                    </th>
                                    <th class="total-summary-column">
                                        <div class="summary-header-cell total-header">
                                            <i class="pi pi-calculator"></i>
                                            <span>Total</span>
                                        </div>
                                    </th>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-customer>
                                <tr class="summary-row">
                                    <td class="customer-name-cell">
                                        <div class="customer-info">
                                            <span class="customer-short">{{ customer.shortName }}</span>
                                            <small class="customer-full">{{ customer.fullName }}</small>
                                        </div>
                                    </td>

                                    <td class="month-data-cell" *ngFor="let month of getDisplayMonths(); let i = index">
                                        <span class="revenue-amount">{{ formatCurrency(customer.monthlyRevenue[i])
                                            }}</span>
                                    </td>

                                    <td class="total-summary-cell">
                                        <div class="total-summary-value">
                                            <strong>{{ formatCurrency(customer.totalRevenue) }}</strong>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="footer">
                                <tr class="summary-total-row">
                                    <td class="customer-name-cell">
                                        <div class="summary-total-label">
                                            <i class="pi pi-chart-bar"></i>
                                            <strong>Grand Total</strong>
                                        </div>
                                    </td>
                                    <td class="month-data-cell" *ngFor="let monthTotal of monthlyRevenueTotals">
                                        <strong class="summary-total-value">{{ formatCurrency(monthTotal) }}</strong>
                                    </td>
                                    <td class="total-summary-cell">
                                        <div class="grand-summary-total">
                                            <strong>{{ formatCurrency(yearlyTotals.total) }}</strong>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>

                <!-- Quantity Summary Table -->
                <div class="summary-panel quantity-summary">
                    <div class="summary-header">
                        <div class="summary-title">
                            <i class="pi pi-box"></i>
                            <h3>Customer Wise Monthly Numbers of Order Intake Summary</h3>
                            <span>Monthly orders by customer</span>
                        </div>
                        <div class="summary-actions">
                            <p-button icon="pi pi-download" styleClass="p-button-text summary-btn"
                                (onClick)="exportSummary('quantity')" pTooltip="Export Quantity Summary">
                            </p-button>
                        </div>
                    </div>

                    <div class="summary-content">
                        <p-table [value]="quantitySummaryData" [scrollable]="true" scrollHeight="600px"
                            styleClass="summary-table quantity-summary-table" [paginator]="false" dataKey="customer">

                            <ng-template pTemplate="header">
                                <tr>
                                    <th class="customer-name-column">
                                        <div class="summary-header-cell">
                                            <i class="pi pi-building"></i>
                                            <span>Customer</span>
                                        </div>
                                    </th>
                                    <th class="month-column" *ngFor="let month of getDisplayMonths()">
                                        <div class="summary-header-cell">
                                            <span>{{ month.shortName }}</span>
                                            <small>{{ month.fullName }}</small>
                                        </div>
                                    </th>
                                    <th class="total-summary-column">
                                        <div class="summary-header-cell total-header">
                                            <i class="pi pi-shopping-cart"></i>
                                            <span>Total</span>
                                        </div>
                                    </th>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-customer>
                                <tr class="summary-row">
                                    <td class="customer-name-cell">
                                        <div class="customer-info">
                                            <span class="customer-short">{{ customer.shortName }}</span>
                                            <small class="customer-full">{{ customer.fullName }}</small>
                                        </div>
                                    </td>

                                    <td class="month-data-cell" *ngFor="let month of getDisplayMonths(); let i = index">
                                        <span class="quantity-amount">{{ formatNumber(customer.monthlyQuantity[i])
                                            }}</span>
                                    </td>

                                    <td class="total-summary-cell">
                                        <div class="total-summary-value">
                                            <strong>{{ formatNumber(customer.totalQuantity) }}</strong>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="footer">
                                <tr class="summary-total-row">
                                    <td class="customer-name-cell">
                                        <div class="summary-total-label">
                                            <i class="pi pi-box"></i>
                                            <strong>Grand Total</strong>
                                        </div>
                                    </td>
                                    <td class="month-data-cell" *ngFor="let monthTotal of monthlyQuantityTotals">
                                        <strong class="summary-total-value">{{ formatNumber(monthTotal) }}</strong>
                                    </td>
                                    <td class="total-summary-cell">
                                        <div class="grand-summary-total">
                                            <strong>{{ formatNumber(yearlyQuantities.total) }}</strong>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </div>
        </div>
        <!-- Accumulative Tables Section -->
        <div class="accumulative-tables-container"
            *ngIf="accumulativeRevenueData && accumulativeRevenueData.length > 0">
            <div class="accumulative-section-header">
                <h2>
                    <i class="pi pi-trending-up"></i>
                    Accumulative Analysis by Customer
                </h2>
                <p>Cumulative monthly performance showing running totals for {{ selectedYear }}</p>
            </div>

            <div class="accumulative-tables-grid">
                <!-- Accumulative Revenue Table -->
                <div class="accumulative-panel revenue-accumulative">
                    <div class="accumulative-header">
                        <div class="accumulative-title">
                            <i class="pi pi-dollar"></i>
                            <h3>Cumulative Order Values</h3>
                            <span>Running total revenue by customer</span>
                        </div>
                        <div class="accumulative-actions">
                            <p-button icon="pi pi-download" styleClass="p-button-text accumulative-btn"
                                (onClick)="exportAccumulative('revenue')" pTooltip="Export Accumulative Revenue">
                            </p-button>
                            <p-button icon="pi pi-chart-line" styleClass="p-button-text accumulative-btn"
                                (onClick)="showRevenueChart()" pTooltip="View Revenue Chart">
                            </p-button>
                        </div>
                    </div>

                    <div class="accumulative-content">
                        <p-table [value]="accumulativeRevenueData" [scrollable]="true" scrollHeight="600px"
                            styleClass="accumulative-table revenue-accumulative-table" [paginator]="false"
                            dataKey="fullName">

                            <ng-template pTemplate="header">
                                <tr>
                                    <th class="customer-name-column">
                                        <div class="accumulative-header-cell">
                                            <i class="pi pi-building"></i>
                                            <span>Customer</span>
                                        </div>
                                    </th>
                                    <th class="month-column" *ngFor="let month of getDisplayMonths()">
                                        <div class="accumulative-header-cell">
                                            <span>{{ month.shortName }}</span>
                                            <small>Cumulative</small>
                                        </div>
                                    </th>
                                    <th class="total-accumulative-column">
                                        <div class="accumulative-header-cell total-header">
                                            <i class="pi pi-calculator"></i>
                                            <span>Final Total</span>
                                        </div>
                                    </th>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-customer>
                                <tr class="accumulative-row">
                                    <td class="customer-name-cell">
                                        <div class="customer-info">
                                            <span class="customer-short">{{ customer.shortName }}</span>
                                            <small class="customer-full">{{ customer.fullName }}</small>
                                        </div>
                                    </td>

                                    <td class="month-data-cell accumulative-data"
                                        *ngFor="let month of getDisplayMonths(); let i = index">
                                        <span class="accumulative-amount revenue-accumulative">
                                            {{ formatCurrency(customer.monthlyAccumulative[i]) }}
                                        </span>
                                        <div class="accumulative-indicator"
                                            *ngIf="i > 0 && customer.monthlyAccumulative[i] > customer.monthlyAccumulative[i-1]">
                                            <i class="pi pi-arrow-up trend-up"></i>
                                        </div>
                                    </td>

                                    <td class="total-accumulative-cell">
                                        <div class="total-accumulative-value">
                                            <strong>{{ formatCurrency(customer.finalTotal) }}</strong>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="footer">
                                <tr class="accumulative-total-row">
                                    <td class="customer-name-cell">
                                        <div class="accumulative-total-label">
                                            <i class="pi pi-chart-bar"></i>
                                            <strong>System Total</strong>
                                        </div>
                                    </td>
                                    <td class="month-data-cell"
                                        *ngFor="let monthTotal of accumulativeRevenueTotals; let i = index">
                                        <strong class="accumulative-total-value">{{ formatCurrency(monthTotal)
                                            }}</strong>
                                    </td>
                                    <td class="total-accumulative-cell">
                                        <div class="grand-accumulative-total">
                                            <strong>{{ formatCurrency(yearlyTotals.total) }}</strong>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>

                <!-- Accumulative Quantity Table -->
                <div class="accumulative-panel quantity-accumulative">
                    <div class="accumulative-header">
                        <div class="accumulative-title">
                            <i class="pi pi-box"></i>
                            <h3>Cumulative Order Numbers</h3>
                            <span>Running total orders by customer</span>
                        </div>
                        <div class="accumulative-actions">
                            <p-button icon="pi pi-download" styleClass="p-button-text accumulative-btn"
                                (onClick)="exportAccumulative('quantity')" pTooltip="Export Accumulative Quantity">
                            </p-button>
                            <p-button icon="pi pi-chart-bar" styleClass="p-button-text accumulative-btn"
                                (onClick)="showQuantityChart()" pTooltip="View Quantity Chart">
                            </p-button>
                        </div>
                    </div>

                    <div class="accumulative-content">
                        <p-table [value]="accumulativeQuantityData" [scrollable]="true" scrollHeight="600px"
                            styleClass="accumulative-table quantity-accumulative-table" [paginator]="false"
                            dataKey="fullName">

                            <ng-template pTemplate="header">
                                <tr>
                                    <th class="customer-name-column">
                                        <div class="accumulative-header-cell">
                                            <i class="pi pi-building"></i>
                                            <span>Customer</span>
                                        </div>
                                    </th>
                                    <th class="month-column" *ngFor="let month of getDisplayMonths()">
                                        <div class="accumulative-header-cell">
                                            <span>{{ month.shortName }}</span>
                                            <small>Cumulative</small>
                                        </div>
                                    </th>
                                    <th class="total-accumulative-column">
                                        <div class="accumulative-header-cell total-header">
                                            <i class="pi pi-shopping-cart"></i>
                                            <span>Final Total</span>
                                        </div>
                                    </th>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-customer>
                                <tr class="accumulative-row">
                                    <td class="customer-name-cell">
                                        <div class="customer-info">
                                            <span class="customer-short">{{ customer.shortName }}</span>
                                            <small class="customer-full">{{ customer.fullName }}</small>
                                        </div>
                                    </td>

                                    <td class="month-data-cell accumulative-data"
                                        *ngFor="let month of getDisplayMonths(); let i = index">
                                        <span class="accumulative-amount quantity-accumulative">
                                            {{ formatNumber(customer.monthlyAccumulative[i]) }}
                                        </span>
                                        <div class="accumulative-indicator"
                                            *ngIf="i > 0 && customer.monthlyAccumulative[i] > customer.monthlyAccumulative[i-1]">
                                            <i class="pi pi-arrow-up trend-up"></i>
                                        </div>
                                    </td>

                                    <td class="total-accumulative-cell">
                                        <div class="total-accumulative-value">
                                            <strong>{{ formatNumber(customer.finalTotal) }}</strong>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="footer">
                                <tr class="accumulative-total-row">
                                    <td class="customer-name-cell">
                                        <div class="accumulative-total-label">
                                            <i class="pi pi-box"></i>
                                            <strong>System Total</strong>
                                        </div>
                                    </td>
                                    <td class="month-data-cell"
                                        *ngFor="let monthTotal of accumulativeQuantityTotals; let i = index">
                                        <strong class="accumulative-total-value">{{ formatNumber(monthTotal) }}</strong>
                                    </td>
                                    <td class="total-accumulative-cell">
                                        <div class="grand-accumulative-total">
                                            <strong>{{ formatNumber(yearlyQuantities.total) }}</strong>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </div>
        </div>

        <!-- Revenue Chart Dialog Component -->
        <app-weekly-chart-dialog [(visible)]="displayRevenueChart" [chartType]="'revenue'"
            [chartData]="revenueChartData" [selectedYear]="selectedYear"
            [customerCount]="accumulativeRevenueData.length" [monthCount]="getDisplayMonths().length"
            [totalValue]="yearlyTotals.total" [formatCurrency]="formatCurrency.bind(this)"
            [formatNumber]="formatNumber.bind(this)" (visibleChange)="displayRevenueChart = $event"
            (exportChart)="onExportChart($event)" (closeDialog)="onRevenueChartClose()">
        </app-weekly-chart-dialog>

        <!-- Quantity Chart Dialog Component -->
        <app-weekly-chart-dialog [(visible)]="displayQuantityChart" [chartType]="'quantity'"
            [chartData]="quantityChartData" [selectedYear]="selectedYear"
            [customerCount]="accumulativeQuantityData.length" [monthCount]="getDisplayMonths().length"
            [totalValue]="yearlyQuantities.total" [formatCurrency]="formatCurrency.bind(this)"
            [formatNumber]="formatNumber.bind(this)" (visibleChange)="displayQuantityChart = $event"
            (exportChart)="onExportChart($event)" (closeDialog)="onQuantityChartClose()">
        </app-weekly-chart-dialog>
    </div>
<p-dialog header="Upload KIK#F1 Excel Data" 
          [(visible)]="showKikF1Upload" 
          [modal]="true" 
          [style]="{width: '600px'}" 
          [closable]="true" 
          styleClass="kikf1-upload-dialog"
          (onHide)="closeKikF1UploadDialog()">
    
    <div class="kikf1-upload-content" [class.upload-loading]="isUploadingKikF1">
        <div class="upload-instructions">
            <h4>Excel File Requirements:</h4>
            <ul>
                <li>Columns: Customer Name, Year, Month, Week, Value, Quantity</li>
                <li>File format: .xlsx or .xls</li>
                <li>Maximum file size: 10MB</li>
            </ul>
        </div>
        
        <div class="file-upload-section" 
             [class.drag-over]="isDragOver"
             (dragover)="onDragOver($event)"
             (dragleave)="onDragLeave($event)"
             (drop)="onDrop($event)">
            
            <p-fileUpload 
                mode="basic" 
                name="excelFile"
                accept=".xlsx,.xls"
                [maxFileSize]="10000000"
                (onSelect)="onKikF1FileUpload($event)"
                chooseLabel="Select Excel File"
                chooseIcon="pi pi-file-excel"
                [disabled]="isUploadingKikF1">
            </p-fileUpload>
            
            <p-progressBar 
                *ngIf="isUploadingKikF1" 
                mode="indeterminate" 
                [style]="{'height': '8px', 'margin-top': '16px'}">
            </p-progressBar>
            
            <div *ngIf="!isUploadingKikF1" class="upload-hint">
                <small>Or drag and drop your Excel file here</small>
            </div>
        </div>
        
        <!-- Upload Results -->
        <div class="upload-results" *ngIf="uploadResults">
            <p-panel header="Upload Results" [collapsed]="false" styleClass="results-panel">
                <div class="results-summary">
                    <div class="result-item">
                        <strong>Total Rows:</strong>
                        <span>{{ uploadResults.totalRows }}</span>
                    </div>
                    <div class="result-item success">
                        <strong>Successful Records:</strong>
                        <span>{{ uploadResults.successfulRecords }}</span>
                    </div>
                    <div class="result-item" *ngIf="uploadResults.errors?.length > 0">
                        <strong>Errors:</strong>
                        <span>{{ uploadResults.errors.length }}</span>
                    </div>
                </div>
                
                <!-- Show errors if any -->
                <div class="errors-section" *ngIf="uploadResults.errors?.length > 0">
                    <h5>Error Details:</h5>
                    <ul class="error-list">
                        <li *ngFor="let error of uploadResults.errors" class="error-item">
                            {{ error }}
                        </li>
                    </ul>
                </div>
            </p-panel>
        </div>
    </div>
    
    <ng-template pTemplate="footer">
        <p-button label="Close" 
                  icon="pi pi-times" 
                  (onClick)="closeKikF1UploadDialog()"
                  styleClass="p-button-text">
        </p-button>
    </ng-template>
</p-dialog>
</div>